// extracted by mini-css-extract-plugin
export default {"root":"SectionGrid31_root__DfSzL","content":"SectionGrid31_content__0poWF","gridContainer":"SectionGrid31_gridContainer__v53k-"};